const LIST_STATE_KEY = "promang:drawings:list";

const structureStateKey = (projectId) =>
  `promang:drawings:structure:${projectId ?? "all"}`;

const toPositiveInt = (value) => {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const projectFromSelectorEvent = (event) => {
  const object = event?.target?.object;
  const item = event?.target?.data;
  if (!object && !item?.id) return null;
  const project = object || { id: item.id, displayTitle: item.primary, name: item.primary };
  return {
    id: project.id,
    displayTitle: project.displayTitle ?? project.name ?? item?.primary ?? "",
  };
};

export const parseDrawingListUrl = (searchParams) => ({
  projectId: toPositiveInt(searchParams.get("project_id")),
  drawingHouseId: toPositiveInt(searchParams.get("drawing_house_id")),
  drawingFloorId: toPositiveInt(searchParams.get("drawing_floor_id")),
  unassigned: searchParams.get("unassigned") === "1" || searchParams.get("unassigned") === "true",
  query: searchParams.get("query") || "",
});

export const buildDrawingListSearchParams = ({
  query,
  projectId,
  drawingHouseId,
  drawingFloorId,
  unassigned,
}) => {
  const params = new URLSearchParams();
  if (query?.trim()) params.set("query", query.trim());
  if (projectId) params.set("project_id", String(projectId));
  if (unassigned) {
    params.set("unassigned", "1");
  } else {
    if (drawingHouseId) params.set("drawing_house_id", String(drawingHouseId));
    if (drawingFloorId) params.set("drawing_floor_id", String(drawingFloorId));
  }
  return params;
};

export const readDrawingListState = () => {
  try {
    if (typeof window !== "undefined") {
      const urlState = parseDrawingListUrl(new URLSearchParams(window.location.search));
      if (
        urlState.projectId ||
        urlState.drawingHouseId ||
        urlState.drawingFloorId ||
        urlState.unassigned ||
        urlState.query
      ) {
        return {
          projectId: urlState.projectId,
          selectedHouseId: urlState.unassigned ? null : urlState.drawingHouseId,
          selectedFloorId: urlState.unassigned ? null : urlState.drawingFloorId,
          selectedAndre: Boolean(urlState.unassigned),
          searchQuery: urlState.query,
        };
      }
    }
    const raw = window.sessionStorage.getItem(LIST_STATE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export const writeDrawingListState = (state) => {
  try {
    window.sessionStorage.setItem(LIST_STATE_KEY, JSON.stringify(state));
  } catch {
    // Best-effort UI state only.
  }
};

export const readDrawingStructureState = (projectId) => {
  try {
    const raw = window.sessionStorage.getItem(structureStateKey(projectId));
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export const writeDrawingStructureState = (projectId, state) => {
  try {
    window.sessionStorage.setItem(structureStateKey(projectId), JSON.stringify(state));
  } catch {
    // Best-effort UI state only.
  }
};
